import { Navigate, Route, Routes } from 'react-router-dom'

import { delmanRouteElements } from '@/router/delmanRoutes'
import { warehouseRouteElements } from '@/router/warehouseRoutes'
import { RootRedirect } from '@/router/RootRedirect'
import { buildAppMode } from '@/shared/buildMode'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      {buildAppMode === 'warehouse' && (
        <>
          <Route path="/delman/*" element={<Navigate to="/warehouse" replace />} />
          {warehouseRouteElements}
        </>
      )}

      {buildAppMode === 'warehouse_delman' && (
        <>
          <Route path="/warehouse/*" element={<Navigate to="/delman" replace />} />
          {delmanRouteElements}
        </>
      )}

      <Route path="*" element={<RootRedirect />} />
    </Routes>
  )
}
